export default __webpack_public_path__ + "static/media/blogImage.804fdc00.jpg";